<template>
  <section class="position-relative mt-5 pt-5" id="customerComment">
    <div class="w-100 position-absolute customerComment-container">
      <div class="title text-center">
        <h2 class="font-w-700 fontsize-heavy mt-5 mt-md-3 text-color-theme-dark">
          نظرات مشتریان خاص ثریا مارکت
        </h2>
        <p class="font-w-400 font-s-14 text-color-theme-dark m-0">
          نظرات مصرف کنندهای محصولات ما
        </p>
      </div>
      <div
        class="customer-comment-swiper position-relative custom-container mt-3"
      >
        <div class="">
          <div class="swiper-container p-3">
            <div class="swiper-wrapper">
              <CustomerCommentCard
                class="swiper-slide"
                :comment="item"
                v-for="(item, index) in data"
                :key="index"
              />
            </div>
          </div>
        </div>
        <div class="next-btn-holder d-none d-xl-block">
          <RightChevIcon />
        </div>
        <div class="prev-btn-holder d-none d-xl-block">
          <RightChevIcon />
        </div>
      </div>
    </div>
    <div class="d-none d-md-block">
      <img
        class="w-100 h-100"
        src="@/assets/images/customercommentBg.png"
        alt=""
      />
    </div>
    <div class="d-md-none d-block">
      <img
        class="w-100 h-100"
        src="@/assets/images/customercommentBgSm.png"
        alt=""
      />
    </div>
  </section>
</template>
<script>
import CustomerCommentCard from "@/parts/Front/components/home/CustomerCommentCard.vue";
import defaultImg from "@/assets/images/user1.png";
import Swiper from "swiper/swiper-bundle.min";
import RightChevIcon from "@/parts/Front/components/Icon/RightChevIcon.vue";

let breakpoints = {
  300: {
    slidesPerView: 1,
    spaceBetween: 15,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  1200: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
};
export default {
  components: {
    CustomerCommentCard,
    RightChevIcon,
  },
  data() {
    return {
      data: [
        {
          id: 1,
          img: defaultImg,
          author: "میثم دیباکار",
          description:
            "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد",
        },
        {
          id: 2,
          img: defaultImg,
          author: "میثم دیباکار",
          description:
            "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد",
        },
        {
          id: 3,
          img: defaultImg,
          author: "میثم دیباکار",
          description:
            "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد",
        },
        {
          id: 4,
          img: defaultImg,
          author: "میثم دیباکار",
          description:
            "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد",
        },
      ],
    };
  },
  mounted() {
    this.initSlider(false);
  },
  methods: {
    initSlider(kill = false) {
      this.initSwiper("customerCommentSwiper", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper(".customer-comment-swiper .swiper-container", {
          loop: false,
          speed: 800,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".customer-comment-swiper .next-btn-holder",
            prevEl: ".customer-comment-swiper .prev-btn-holder",
          },
          breakpoints,
        });
      });
    },
  },
};
</script>
<style scoped>
#customerComment .customerComment-container {
  user-select: none;
  top: 50%;
  transform: translateY(-50%);
}
#customerComment .customer-comment-swiper {
  /* transform: scale(0.75); */
}
#customerComment .next-btn-holder {
  top: 50%;
  left: 101%;
  position: absolute;
  width: fit-content;
  padding: 12px;
  border-radius: 42% 58% 18% 82% / 64% 42% 58% 36%;
  background-color: var(--color-theme3);
  transform: translateY(-50%);
}
#customerComment .prev-btn-holder {
  top: 50%;
  right: 101%;
  position: absolute;
  width: fit-content;
  padding: 12px;
  border-radius: 42% 58% 18% 82% / 64% 42% 58% 36%;
  background-color: var(--color-theme3);
  transform: rotateY(180deg) translateY(-50%);
}
</style>
